import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUdemyComponent } from './simple-icons-udemy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUdemyComponent ],
    exports:      [ SimpleIconsUdemyComponent ],
    bootstrap:    []
})
export class SimpleIconsUdemyModule {}
